module.exports = __webpack_public_path__ + "static/media/s_sf_10.43a977d0.png";